document.addEventListener("click", (e) => {
  if (e.target.closest("#prd-buy-button")) {
    e.preventDefault();

    const container = e.target.closest(".quick-buy-modal, .product, .product-form");
    const moreBtn = container?.querySelector(".shopify-payment-button__more-options");

    if (moreBtn) {
      moreBtn.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    } else {
      console.warn("More payment options button not found.");
    }
  }
});